import React from "react";

const Restrictions = () => <div className='restrictions'>Use of some materials is restricted upon Participant's request.</div>

export default Restrictions;